<form
  class="field-dialog__content__scroll p-24"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  *ngIf="locationForm"
  fxLayout="column"
  name="form"
  autocomplete="off"
  [formGroup]="locationForm"
  fusePerfectScrollbar
>
  <div class="card mb-30" fxLayout="column">
    <div class="card__label" fxLayout="row">
      <label class="card-title">
        {{ 'LOCATIONS.DIALOG.GENERAL_INFORMATION' | translate }}
      </label>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy" fxFlex class="pr-4">
        <mat-label> {{ 'LOCATIONS.DIALOG.NAME' | translate }}</mat-label>
        <mat-hint align="end"> {{ locationForm.get('name').value?.length || 0 }}/100 </mat-hint>

        <input matInput formControlName="name" required autocomplete="off" />

        <mat-error *ngIf="locationForm.get('name').hasError('required')">
          {{ 'LOCATIONS.ERRORS.NAME_REQUIRED' | translate }}
        </mat-error>
        <mat-error *ngIf="locationForm.get('name').hasError('location_name_duplicated')">
          {{ 'LOCATIONS.ERRORS.NAME_DUPLICATED' | translate }}
        </mat-error>
        <mat-error *ngIf="locationForm.get('name').hasError('maxlength')">
          {{ 'LOCATIONS.ERRORS.NAME_MAX_LENGTH' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center" fxFlex="100">
      <mat-form-field appearance="legacy" fxFlex class="pr-4" fxFlex="50">
        <mat-label> {{ 'LOCATIONS.DIALOG.DOCUMENT_NUMBER' | translate }}</mat-label>

        <input data-cy="document-number-input" matInput formControlName="documentNumber" autocomplete="off" />

        <mat-error *ngIf="locationForm.get('documentNumber').errors?.maxlength">
          {{ 'LOCATIONS.ERRORS.DOCUMENT_NUMBER.MAX_LENGTH' | translate }}
        </mat-error>

        <mat-error data-cy="err-invalid-cpf" *ngIf="locationForm.get('documentNumber').errors?.invalidCPF">
          {{ 'LOCATIONS.ERRORS.DOCUMENT_NUMBER.INVALID_CPF' | translate }}
        </mat-error>

        <mat-error data-cy="err-invalid-cnpj" *ngIf="locationForm.get('documentNumber').errors?.invalidCNPJ">
          {{ 'LOCATIONS.ERRORS.DOCUMENT_NUMBER.INVALID_CNPJ' | translate }}
        </mat-error>

        <mat-error *ngIf="locationForm.get('documentNumber').hasError('document_number_name_duplicated')">
          {{ 'LOCATIONS.ERRORS.DOCUMENT_NUMBER.DUPLICATED' | translate }}
        </mat-error>
      </mat-form-field>

      <locations-groups
        [control]="locationForm.get('locationGroup')"
        [requiredMark]="true"
        [preloadOptions]="true"
        [translateErrorPrefix]="'LOCATIONS.ERRORS.LOCATION_GROUP'"
      ></locations-groups>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center" class="segments-selector">
      <fc-segments-input
        [control]="locationForm.get('segmentsId')"
        [shouldDisplayArchived]="true"
        [desiredStyle]="desiredStyle"
        [disabled]="isViewMode"
      ></fc-segments-input>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy" fxFlex="100">
        <mat-label>{{ 'LOCATIONS.DIALOG.NOTES' | translate }}</mat-label>
        <mat-hint align="end"> {{ locationForm.get('notes').value?.length || 0 }}/2000 </mat-hint>

        <input matInput formControlName="notes" maxlength="2000" autocomplete="off" />
      </mat-form-field>
    </div>
  </div>

  <mat-radio-group
    class="address-search-options"
    [formControl]="locationForm.get('searchingWithGoogle')"
    fxLayout="row"
  >
    <mat-radio-button class="address-search-options__option" [value]="true">
      <div>Buscar por Google</div>
    </mat-radio-button>
    <mat-radio-button class="address-search-options__option" [value]="false">
      <div>Buscar por CEP</div>
    </mat-radio-button>
  </mat-radio-group>

  <div
    class="card"
    formGroupName="address"
    fxLayout="column"
    [ngClass]="{
      'has-coord-error-border':
        locationForm.get('address').invalid && locationForm.get('address').get('postalCode').touched
    }"
  >
    <div class="card__label" fxLayout="row">
      <label
        class="card-title"
        [ngClass]="{
          'has-coord-error-color':
            locationForm.get('address').invalid && locationForm.get('address').get('postalCode').touched
        }"
      >
        {{ 'LOCATIONS.HEADER.ADDRESS' | translate }}
      </label>
    </div>
    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <address fxFlex="100" [addressForm]="locationForm.get('address')" [isViewMode]="isViewMode"></address>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy" fxFlex="33" fxFlex.xs="100" class="pr-4" maxlength="8">
        <mat-label>{{ 'LOCATIONS.DIALOG.ZIPCODE' | translate }}</mat-label>

        <input
          matInput
          formControlName="postalCode"
          autocomplete="off"
          pattern="^[a-zA-Z0-9]*$"
          (input)="onInput($event)"
        />

        <mat-error *ngIf="locationForm.get('address').get('postalCode').hasError('mask')">
          {{ 'LOCATIONS.ERRORS.ZIPCODE_PATTERN' | translate }}
        </mat-error>

        <mat-error *ngIf="locationForm.get('address').get('postalCode').hasError('maxlength')">
          {{ 'LOCATIONS.ERRORS.ZIPCODE_MAX_LENGTH' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field formGroupName="coords" appearance="legacy" fxFlex="33" fxFlex.xs="100" class="pr-4">
        <mat-label> {{ 'LOCATIONS.DIALOG.TABS.TAB_LOCATION.LATITUDE' | translate }}</mat-label>
        <input
          matInput
          type="number"
          required
          formControlName="latitude"
          autocomplete="off"
          pattern="^-?\d+(\.\d+)?$"
        />
      </mat-form-field>

      <mat-form-field formGroupName="coords" appearance="legacy" fxFlex="33" fxFlex.xs="100" class="px-4">
        <mat-label> {{ 'LOCATIONS.DIALOG.TABS.TAB_LOCATION.LONGITUDE' | translate }}</mat-label>
        <input matInput type="number" required formControlName="longitude" autocomplete="off" />
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy" fxFlex="80" fxFlex.xs="100" class="px-4">
        <mat-label> {{ 'LOCATIONS.DIALOG.CITY' | translate }}</mat-label>
        <mat-hint align="end"> {{ locationForm.get('address').get('city').value?.length || 0 }}/80 </mat-hint>

        <input matInput formControlName="city" required maxlength="80" autocomplete="off" />
        <mat-progress-bar mode="indeterminate" *ngIf="postalCodeIsLoading"></mat-progress-bar>

        <mat-error>
          {{ 'LOCATIONS.ERRORS.CITY_REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="20" fxFlex.xs="100" class="pl-4">
        <mat-label> {{ 'LOCATIONS.DIALOG.STATE' | translate }}</mat-label>
        <mat-hint align="end"> {{ locationForm.get('address').get('state').value?.length || 0 }}/20 </mat-hint>

        <input matInput formControlName="state" maxlength="20" required autocomplete="off" />
        <mat-progress-bar mode="indeterminate" *ngIf="postalCodeIsLoading"></mat-progress-bar>

        <mat-error *ngIf="locationForm.get('address').get('state').errors?.required">
          {{ 'LOCATIONS.ERRORS.STATE_REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy" fxFlex="55" fxFlex.xs="100" class="pr-4">
        <mat-label>{{ 'LOCATIONS.DIALOG.STREET' | translate }}</mat-label>
        <mat-hint align="end"> {{ locationForm.get('address').get('streetName').value?.length || 0 }}/200 </mat-hint>

        <input matInput formControlName="streetName" maxlength="200" autocomplete="off" />
        <mat-progress-bar mode="indeterminate" *ngIf="postalCodeIsLoading"></mat-progress-bar>
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="30" fxFlex.xs="100" class="pl-4">
        <mat-label> {{ 'LOCATIONS.DIALOG.NEIGHBORHOOD' | translate }}</mat-label>
        <mat-hint align="end"> {{ locationForm.get('address').get('neighborhood').value?.length || 0 }}/80 </mat-hint>

        <input matInput formControlName="neighborhood" maxlength="80" autocomplete="off" />
        <mat-progress-bar mode="indeterminate" *ngIf="postalCodeIsLoading"></mat-progress-bar>
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="15" fxFlex.xs="100" class="px-4">
        <mat-label> {{ 'LOCATIONS.DIALOG.NUMBER' | translate }}</mat-label>
        <mat-hint align="end"> {{ locationForm.get('address').get('number').value?.length || 0 }}/50 </mat-hint>

        <input matInput formControlName="number" maxlength="50" autocomplete="off" />
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy" fxFlex="100">
        <mat-label>{{ 'LOCATIONS.DIALOG.COMPLEMENT' | translate }}</mat-label>
        <mat-hint align="end"> {{ locationForm.get('address').get('complement').value?.length || 0 }}/100 </mat-hint>

        <input matInput formControlName="complement" maxlength="100" autocomplete="off" />
      </mat-form-field>
    </div>

    <div *ngIf="locationForm.get('searchingWithGoogle').value" formGroupName="coords">
      <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center"></div>
    </div>

    <mat-error
      *ngIf="locationForm.get('address').invalid && locationForm.get('address').get('postalCode').touched"
      class="custom-error"
    >
      {{ 'LOCATIONS.ERRORS.COORDS_INVALID' | translate }}
    </mat-error>
  </div>
</form>
